import { createUseStyles } from '@pe-libs/react-components/build/theme';

const useStyles = createUseStyles(
  'default-thank-you-page',
  ({
    palette: { common },
    breakpoints: {
      down,
      values: { lg },
    },
  }) => ({
    container: {
      minHeight: '100vh',
      backgroundColor: common.white,
    },
    header: {
      width: '100%',
      maxWidth: `${lg}px`,
      margin: '0 auto',
      padding: '0.25rem 1rem',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      [down('xs')]: {
        padding: '0.25rem 0.5rem',
      },
    },
    PELogo: {
      height: '3.5rem',
    },
    wrapper: {
      minHeight: 'calc(100vh - 8.625rem)',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      maxWidth: '818px',
      margin: '0 auto',
      padding: '0 1.5rem',
      [down('xs')]: {
        padding: '0 1rem',
        textAlign: 'center',
      },
    },
    title: {
      marginTop: '3.5rem',
      textAlign: 'center',
    },
    subtitle: {
      marginTop: '0.75rem',
      [down('xs')]: {
        fontSize: '1rem',
      },
    },
    content: {
      marginTop: '4.06rem',
      display: 'flex',
      justifyContent: 'space-between',
      [down('xs')]: {
        marginTop: '2.5rem',
        flexDirection: 'column-reverse',
        alignItems: 'center',
      },
    },
    info: {
      maxWidth: '23.25rem',
      marginRight: '1.5rem',
      flexShrink: 2,
      [down('xs')]: {
        marginTop: '2.25rem',
        marginRight: 0,
        textAlign: 'center',
        maxWidth: '100%',
      },
    },
    linkInput: {
      width: '17.69rem',
      height: '2.5rem',
      backgroundColor: 'rgba(0, 0, 0, 0.1)',
      boxShadow: 'inset 0 1px 3px 0 rgba(0, 0, 0, 0.1)',
      borderRadius: '0.25rem',
      margin: '1rem 0 0.75rem',
      [down('xs')]: {
        width: '100%',
      },
    },
    button: {
      width: '17.69rem',
      marginBottom: '2rem',
      '& .MuiButton-startIcon': {
        fontSize: '1.25rem',
      },
      [down('xs')]: {
        width: '100%',
      },
    },
    socialButtonContainer: {
      marginTop: '1rem',
      '& a': {
        fontSize: '2rem',
        cursor: 'pointer',
        '&:not(last-child)': {
          marginRight: '0.5rem',
        },
      },
    },
    toastWrapper: {
      display: 'flex',
      alignItems: 'center',
    },
    successMessage: {
      paddingLeft: '0.5em',
    },
  }),
);

export default useStyles;
